export const TYPE_BADGE_COLORS = {
  string: 'bg-gray-100 text-gray-600',
  number: 'bg-blue-100 text-blue-600',
  array: 'bg-amber-100 text-amber-600',
  object: 'bg-purple-100 text-purple-600',
  boolean: 'bg-green-100 text-green-600',
};
